import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { Fragment } from 'preact';
import { hasTextContent } from '../utils';
import { useIsMobile } from '../utils/responsive';
import { createDebugLogger } from '../utils/debug';
const debug = createDebugLogger('MiniText');
export function MiniText({ offer, styles }) {
    const isMobile = useIsMobile();
    if (!hasTextContent(offer.mini_text_html)) {
        debug.log('No mini text html');
        return null;
    }
    const containerStyles = {
        padding: '0px 24px 0px 24px',
        fontSize: '9px',
        lineHeight: '1.4',
        color: styles.offerText?.textColor || '#666',
        fontFamily: styles.offerText?.font || 'Roboto, sans-serif',
        // make it italic and small font will be 9px
        fontStyle: 'italic',
        fontWeight: 'normal',
        textAlign: isMobile ? 'center' : 'left',
        width: '100%'
    };
    return (_jsxs(Fragment, { children: [_jsx("style", { children: `
          #adpx_mini-text p {
            padding: 0;
            margin: 0;
            font-size: inherit;
            line-height: inherit;
            color: inherit;
            font-family: inherit;
            font-style: inherit;
            font-weight: inherit;
            text-align: inherit;
          }
          #adpx_mini-text ul,
          #adpx_mini-text ol {
            margin: 0;
            padding-left: 20px;
            text-align: inherit;
          }
        ` }), _jsx("div", { id: 'adpx_mini-text', style: containerStyles, dangerouslySetInnerHTML: { __html: offer.mini_text_html || '' } })] }));
}
